import React from "react";
import { observer } from "mobx-react";
import { UserNotificationPreferenceUpdateStore } from "../../store";
import { UserNotificationPreferenceUpdateForm } from "./UserNotificationPreferenceUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";
import { NotificationType } from "../../../../api/graphql";
import { EmailFrequency } from "../../../../api/graphql";

export type UserNotificationPreferenceUpdateProps = {
  userNotificationPreferenceUpdateStore: UserNotificationPreferenceUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const UserNotificationPreferenceUpdate: React.FC<UserNotificationPreferenceUpdateProps> =
  observer(
    ({
      userNotificationPreferenceUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={userNotificationPreferenceUpdateStore.isSaving}
          />
          <OutdatedAfterSaveNotice
            open={userNotificationPreferenceUpdateStore.savedButOutdated}
            onReload={() =>
              userNotificationPreferenceUpdateStore.reloadUserNotificationPreference()
            }
            reloadDisabled={userNotificationPreferenceUpdateStore.isProcessing}
          />
          <UserNotificationPreferenceUpdateForm
            userNotificationPreferenceUpdateStore={
              userNotificationPreferenceUpdateStore
            }
            notificationTypeError={
              userNotificationPreferenceUpdateStore.errors.notificationType
                ?.message
            }
            notificationTypeOptions={userNotificationPreferenceUpdateStore.getNotificationTypeOptions()}
            onNotificationTypeChange={(value: NotificationType) => {
              userNotificationPreferenceUpdateStore.setNotificationTypeValue(
                value
              );
            }}
            notificationType={
              userNotificationPreferenceUpdateStore.entityValues
                .notificationType
            }
            inAppEnabledError={
              userNotificationPreferenceUpdateStore.errors.inAppEnabled?.message
            }
            onInAppEnabledChange={(value: boolean) => {
              userNotificationPreferenceUpdateStore.setInAppEnabledValue(value);
            }}
            inAppEnabled={
              userNotificationPreferenceUpdateStore.entityValues.inAppEnabled
            }
            emailEnabledError={
              userNotificationPreferenceUpdateStore.errors.emailEnabled?.message
            }
            onEmailEnabledChange={(value: boolean) => {
              userNotificationPreferenceUpdateStore.setEmailEnabledValue(value);
            }}
            emailEnabled={
              userNotificationPreferenceUpdateStore.entityValues.emailEnabled
            }
            emailFrequencyError={
              userNotificationPreferenceUpdateStore.errors.emailFrequency
                ?.message
            }
            emailFrequencyOptions={userNotificationPreferenceUpdateStore.getEmailFrequencyOptions()}
            onEmailFrequencyChange={(value: EmailFrequency) => {
              userNotificationPreferenceUpdateStore.setEmailFrequencyValue(
                value
              );
            }}
            emailFrequency={
              userNotificationPreferenceUpdateStore.entityValues.emailFrequency
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={userNotificationPreferenceUpdateStore.saveDisabled}
            onSave={() =>
              userNotificationPreferenceUpdateStore.saveUserNotificationPreference()
            }
            onCancel={() =>
              userNotificationPreferenceUpdateStore.cancelUserNotificationPreference()
            }
          />
          <ErrorDialog
            open={userNotificationPreferenceUpdateStore.errorDialogOpened}
            title={userNotificationPreferenceUpdateStore.errorTitle}
            description={userNotificationPreferenceUpdateStore.errorDescription}
            onClose={() =>
              userNotificationPreferenceUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={userNotificationPreferenceUpdateStore.confirmDialogOpened}
            title={userNotificationPreferenceUpdateStore.confirmDialogTitle}
            description={
              userNotificationPreferenceUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              userNotificationPreferenceUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              userNotificationPreferenceUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
